import React from 'react';
import { ListRenderItem } from 'react-native';

import FlatList, { EncapsulatedFlatListProps } from '@components/FlatList';
import { GroupData, LargeGroupCard, SmallGroupCard } from '@components/Group/Card';

type LargeGroupCardListProps = EncapsulatedFlatListProps<
  GroupData,
  Omit<React.ComponentProps<typeof LargeGroupCard>, 'data'>
>;

export function LargeGroupCardList({ itemProps, ...props }: LargeGroupCardListProps) {
  const renderItem: ListRenderItem<GroupData> = ({ item }) => (
    <LargeGroupCard data={item} {...itemProps} />
  );

  const keyExtractor = (item: GroupData, index: number) => item.groupId;

  return (
    <FlatList
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      initialNumToRender={5}
      maxToRenderPerBatch={5}
      windowSize={5}
      {...props}
    />
  );
}

type SmallGroupCardListProps = EncapsulatedFlatListProps<
  GroupData,
  Omit<React.ComponentProps<typeof SmallGroupCard>, 'data'>
>;

export function SmallGroupCardList({ itemProps, ...props }: SmallGroupCardListProps) {
  const renderItem: ListRenderItem<GroupData> = ({ item }) => (
    <SmallGroupCard data={item} {...itemProps} />
  );

  const keyExtractor = (item: GroupData, index: number) => item.groupId;

  return (
    <FlatList
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      initialNumToRender={3}
      maxToRenderPerBatch={3}
      windowSize={5}
      {...props}
    />
  );
}
